module.exports = __webpack_public_path__ + "img/owen_vase.75b83eb6.png";